<template>
  <div class="popWrap nowOpen">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">리뷰 등록</h1>
          </div>
          <div class="popBody" style="overflow: auto">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="prdItem xs">
                  <div class="imgArea">
                    <span class="img">
                      <img
                        :src="reviewObj.productInfo.product.thumbnail ? reviewObj.productInfo.product.thumbnail : '/img/error_image.jpg'"
                        :alt="reviewObj.productInfo.product.displayName"
                        onerror="this.src='/img/error_image.jpg';"
                      />
                    </span>
                  </div>
                  <div class="infoArea">
                    <div class="tit row2">
                      <span v-text="reviewObj.productInfo.product.productName"></span>
                    </div>
                    <div class="txtItem">
                      <span v-text="reviewObj.productInfo.product.model"></span>
                      <span v-text="reviewObj.productInfo.product.color"></span>
                    </div>
                    <div class="txtItem pointC6">
                      <span>구매일자 : {{ reviewObj.productInfo.orderDate }}</span>
                    </div>
                  </div>
                </div>
              </section>

              <section class="hr">
                <div class="titArea ac">
                  <h2 class="titH4">상품은 만족하셨나요?</h2>
                </div>
                <div class="reviewStar">
                  <div class="star">
                    <a href="#starText1" id="1" class="icoStar" @click="selectAverageScore('1')"><span class="blind">1</span></a>
                    <a href="#starText2" id="2" class="icoStar" @click="selectAverageScore('2')"><span class="blind">2</span></a>
                    <a href="#starText3" id="3" class="icoStar" @click="selectAverageScore('3')"><span class="blind">3</span></a>
                    <a href="#starText4" id="4" class="icoStar" @click="selectAverageScore('4')"><span class="blind">4</span></a>
                    <a href="#starText5" id="5" class="icoStar" @click="selectAverageScore('5')"><span class="blind">5</span></a>
                  </div>
                  <p class="txt placeholder">선택하세요.</p>
                  <p class="txt" id="starText1">1점 (별로예요)</p>
                  <p class="txt" id="starText2">2점 (그저그래요)</p>
                  <p class="txt" id="starText3">3점 (괜찮아요)</p>
                  <p class="txt" id="starText4">4점 (좋아요)</p>
                  <p class="txt" id="starText5">5점 (최고예요)</p>
                </div>

                <div class="titArea ac">
                  <h2 class="titH4">어떤점이 좋았나요?</h2>
                </div>
                <div class="iptWrap">
                  <textarea class="ipt" title="리뷰 내용 입력" placeholder="최소 20자 이상 입력해주세요." v-model="contents"></textarea>
                  <!-- TODO 기획서에 없는 항목이며 최대 글자수? byte 수 조차도 placeholer와 일치하지 않음. 확인 필요
                  <div class="numByte"><span class="val">0</span> / 5,000</div> -->
                </div>

                <div class="btnArea" v-if="imgList.length < 2">
                  <button type="button" class="btn_s addPic" @click="clickImgAdd">
                    <span class="ico"><img src="@/../static/img/mw/common/ico_picture.png" /></span>
                    사진 첨부하기
                  </button>
                  <input type="file" id="file" style="display: none" @change="selectImg($event)" />
                </div>

                <ul class="thumList div_2 al">
                  <li v-for="(img, fileIndex) in imgList" :key="fileIndex">
                    <div class="block">
                      <img
                        v-if="img.fileTpMCntn != null && img.fileTpMCntn != 'undefined'"
                        :src="`data:image/${img.fileTpMCntn === 'jpg' ? 'jpeg' : img.fileTpMCntn};base64,${img.file}`"
                        style="width: 100%; height: 100%"
                        name="reviewFile"
                      />
                      <img v-else :src="img" style="width: 100%; height: 100%" name="reviewFile" />
                      <button type="button" class="delBtn" @click="deleteImg(fileIndex)"><span class="blind">선택된 사진 삭제</span></button>
                    </div>
                  </li>
                </ul>

                <ul class="txtList_star txtXS mt15">
                  <li>사진은 최대 2장까지 업로드 가능합니다.</li>
                  <li>파일 용량은 20MB 이하로 업로드 가능합니다.</li>
                  <li class="pointC1">상품과 관련이 없거나 부적합한 사진을 등록하는 경우, 포인트 회수 및 사진이 삭제될 수 있습니다.</li>
                </ul>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>
          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="insertReview" :disabled="regButtonShow">등록</button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
    <MessagePop v-if="messagePop2" @close="inputPopClose">
      <p v-html="msg"></p>
    </MessagePop>
    <ProgressBar ref="progress"></ProgressBar>
  </div>
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
import MessagePop from '@/components/popup/MessagePop';
import ApiService from '@/common/api.service';
import { isEmpty } from '@/common/common.function';
import { INPUT_AVERAGESCORE, INPUT_CONTENTS, MAX_FILE_SIZE_CHECK } from '@/store/message.type.js';
import ProgressBar from '@/views/app/comm/ProgressBar';

export default {
  name: 'MyReviewInsertPop',
  components: {
    MessagePop,
    ProgressBar,
  },
  props: ['propsReviewObj', 'imgList'],
  data() {
    return {
      reviewObj: this.propsReviewObj,

      averageScore: null,
      contents: null,

      files: [], // 실제 업로드될 파일 리스트
      fileInput: null,

      msg: null,
      messagePop: null,
      messagePop2: null,

      regButtonShow: true,
      fileAuth: String,
    };
  },
  watch: {
    averageScore() {
      this.checkInput();
    },
    contents() {
      this.checkInput();
    },
    fileAuth() {
      if (this.fileAuth == 'false') {
        this.msg = `아이폰 설정 → welrixrental 앱 → <br/>사진, 카메라 권한을 허용해주세요.`;
        this.messagePop = true;
      }
    },
  },
  mounted() {
    if (this.imgList != undefined && this.imgList != null) {
      this.imgList.forEach((element) => {
        const imgData = atob(element.file);
        const len = imgData.length;
        const array = new Array(len);

        for (let i = 0; i < len; i++) {
          array[i] = imgData.charCodeAt(i) & 0xff; // 비트 마스킹을 통해 msb를 보호한다.
        }

        const byteArray = new Uint8Array(array);
        let blob = new Blob([byteArray], { type: `image/${element.fileTpMCntn === 'jpg' ? 'jpeg' : element.fileTpMCntn}` });
        let file = new File([blob], element.exstFileLNm, { type: `image/${element.fileTpMCntn === 'jpg' ? 'jpeg' : element.fileTpMCntn}` });
        this.files.push(file);
      });
    }
    // 별점 관련 jquery
    customjs.starInit();

    if (this.reviewObj.reviewId) {
      document.getElementById(this.reviewObj.averageScore).click();
      this.averageScore = this.reviewObj.averageScore;
      this.contents = this.reviewObj.contents;
    }
  },
  methods: {
    selectAverageScore(averageScore) {
      this.averageScore = averageScore;
    },
    clickImgAdd() {
      // AsInfo, MyQnaInsertPop, MyReviewInsertPop
      document.getElementById('file').click();
      // if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      //   this.fileAuth = '';
      //   window.getIosFileAuth();
      //   setTimeout(() => {
      //     this.fileAuth = window.getFileAuthCheckValue();
      //   }, 100);
      // } else {
      //   document.getElementById('file').click();
      // }
    },
    selectImg(event) {
      let file = event.target.files[0];
      this.files.push(file);
      this.imgList.push(URL.createObjectURL(file));
    },
    deleteImg(index) {
      this.files.splice(index, 1);
      this.imgList.splice(index, 1);
    },
    insertReview() {
      if (isEmpty(this.averageScore)) {
        this.msg = INPUT_AVERAGESCORE;
        this.messagePop = true;
        return false;
      }

      if (isEmpty(this.contents)) {
        this.msg = INPUT_CONTENTS;
        this.messagePop = true;
        return false;
      }

      let maxFileSize = 10 * 1024 * 1024;
      let fileSize = 0;
      for (let file of this.files) {
        fileSize += file.size;
      }

      if (maxFileSize < fileSize) {
        this.msg = MAX_FILE_SIZE_CHECK;
        this.messagePop = true;
        return false;
      }

      let url = '';

      if (this.reviewObj.reviewId) {
        url = '/user/auth/review/modify';
        this.msg = '리뷰 수정이 완료되었습니다.';
      } else {
        url = '/user/auth/review';
        this.msg = '리뷰 등록이 완료되었습니다.';
      }

      let paramObj = new Object();
      let request = new Object();

      request.reviewId = this.reviewObj.reviewId;
      request.averageScore = this.averageScore;
      request.contents = this.contents;
      request.orderId = this.reviewObj.productInfo.orderId;
      request.productCode = this.reviewObj.productInfo.product.productCode;
      request.fileMngId = this.reviewObj.fileMngId;

      /*
      let imgList = [];
      const reviewFiles = document.getElementsByName('reviewFile');
      for (let i = 0; i < reviewFiles.length; i++) {
        imgList.push(reviewFiles[i].src);
      }
      request.imgList = imgList;
      */

      paramObj.request = request;
      paramObj.serviceType = 'app';

      let formData = new FormData();
      for (let file of this.files) {
        formData.append('files', file);
      }
      formData.append('param', JSON.stringify(paramObj));

      let contentType = new Object();
      contentType.headers = { 'Content-Type': 'multipart/form-data' };
      this.$refs.progress.loadingStart();
      ApiService.service('POST', url, formData, contentType)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.messagePop2 = true;

            if (this.$parent.$options.name == 'ProductDetailTab') {
              this.$parent.$parent.selectProductInfo();
              this.$parent.selectReviewList();
            } else if (this.$parent.$options.name == 'MyReview') {
              this.$parent.selectReviewObjList();
              this.$parent.selectReviewList();
            }
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(() => {
          this.msg = '리뷰 등록에 실패했습니다.<br>지속 발생 시 고객센터로 문의 바랍니다.';
          this.messagePop = true;
          return false;
        })
        .finally(() => {
          this.$refs.progress.loadingEnd();
        });
    },
    inputPopClose() {
      this.messagePop2 = false;
      this.$emit('close');
    },
    checkInput() {
      if (!isEmpty(this.averageScore) && !isEmpty(this.contents)) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
};
</script>
